<div class="page">
  <app-simplified-header style="width: 100%"></app-simplified-header>
  <section class="content">
    <div class="privacy-policy-container">
      <div class="privacy-policy">
        <h2>Informativa Privacy</h2>
        <div class="privacy-policy-content" [innerHTML]="policyContent"></div>
      </div>
    </div>
  </section>
</div>
